<template>
  <section class="rh-seven-result">
    <div class="rh-seven-head">
      <div>
        <p class="rh-seven-eyebrow">AVALIAÇÃO DA LIDERANÇA · 7D</p>        
        <p v-if="resultado">{{ resultado.nomeCiclo }} · {{ resultado.equipe }} · {{ resultado.respostasEquipe }} respostas da equipe</p>
      </div>
    </div>
    <div v-if="!resultado || !resultado.dimensoes || !resultado.dimensoes.length" class="rh-seven-empty">
      As médias aparecem após o encerramento do ciclo e {{ resultado ? resultado.minimoRespostas : 'o mínimo de' }} respostas da equipe.
    </div>
    <template v-else>
      <div class="rh-seven-legend"><span><i class="rh-seven-auto"></i>Autoavaliação</span><span><i class="rh-seven-team"></i>Visão da equipe</span></div>
      <div v-for="dimensao in resultado.dimensoes" :key="dimensao.id" class="rh-seven-row">
        <strong class="rh-seven-name">{{ dimensao.nome }}</strong>
        <div class="rh-seven-bars">
          <div class="rh-seven-line"><div class="rh-seven-track"><span class="rh-seven-auto" :style="{ width: largura(dimensao.mediaAuto) }"></span></div><strong>{{ nota(dimensao.mediaAuto) }}</strong></div>
          <div class="rh-seven-line"><div class="rh-seven-track"><span class="rh-seven-team" :style="{ width: largura(dimensao.mediaEquipe) }"></span></div><strong>{{ nota(dimensao.mediaEquipe) }}</strong></div>
        </div>
        <span v-if="dimensao.diferenca !== null" class="rh-seven-delta" :class="dimensao.diferenca < -0.3 ? 'negative' : dimensao.diferenca > 0.3 ? 'positive' : 'neutral'">{{ dimensao.diferenca > 0 ? '+' : '' }}{{ nota(dimensao.diferenca) }}</span>
      </div>
      <p v-if="!resultado.autoRespondida" class="rh-seven-note">A autoavaliação do líder ainda não foi enviada.</p>
      <p class="rh-seven-note">Diferença = visão da equipe menos autoavaliação. Escala de 1 a 5.</p>
    </template>
  </section>
</template>

<script>
export default {
  name: 'RhResultado7D',
  props: { resultado: { type: Object, default: null } },
  methods: {
    nota(valor) { return valor === null || valor === undefined ? '—' : Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) },
    largura(valor) { return valor === null || valor === undefined ? '0%' : `${Math.max(0, Math.min(100, Number(valor) * 20))}%` },
  },
}
</script>

<style scoped>
.rh-seven-result { background: #fff; border-radius: 18px; padding: 26px 32px; color: #071a42; }
.rh-seven-head h2 { margin: 4px 0; font-size: 22px; }
.rh-seven-head p { margin: 0; color: #61708a; }
.rh-seven-eyebrow { font-size: 11px; font-weight: 700; letter-spacing: .1em; color: #0078fa !important; }
.rh-seven-legend { display: flex; gap: 18px; padding: 22px 0 14px; font-size: 13px; color: #465574; }
.rh-seven-legend span { display: flex; align-items: center; gap: 6px; }
.rh-seven-legend i { width: 10px; height: 10px; border-radius: 3px; display: inline-block; }
.rh-seven-auto { background: #adc4f2; }
.rh-seven-team { background: #087dff; }
.rh-seven-row { display: grid; grid-template-columns: minmax(140px, 1.4fr) minmax(180px, 1.4fr) 65px; gap: 18px; align-items: center; padding: 18px 0; border-top: 1px solid #e8ebef; }
.rh-seven-name { font-size: 16px; }
.rh-seven-bars { display: grid; gap: 9px; }
.rh-seven-line { display: grid; grid-template-columns: minmax(90px, 1fr) 38px; gap: 12px; align-items: center; font-size: 14px; }
.rh-seven-track { height: 8px; border-radius: 8px; background: #eaeaea; overflow: hidden; }
.rh-seven-track span { display: block; height: 100%; border-radius: inherit; }
.rh-seven-delta { justify-self: end; padding: 5px 9px; border-radius: 20px; font-weight: 700; font-size: 13px; }
.rh-seven-delta.negative { color: #bc2d17; background: #fce7e4; }
.rh-seven-delta.positive { color: #08795d; background: #dff5ec; }
.rh-seven-delta.neutral { color: #8a6200; background: #fff3d6; }
.rh-seven-note, .rh-seven-empty { color: #60708b; font-size: 13px; }
@media (max-width: 650px) { .rh-seven-result { padding: 20px; } .rh-seven-row { grid-template-columns: 1fr 55px; gap: 8px; } .rh-seven-name { grid-column: 1 / -1; } }
</style>
